import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'html-editor',
    templateUrl: './html-editor.component.html',
    styleUrls: ['./html-editor.component.scss'],
    standalone: false
})
export class HtmlEditorComponent implements OnInit {
  private static readonly CKEDITOR_URL = 'https://cdn.ckeditor.com/4.10.1/full/ckeditor.js';
  private static ckeditorLoad: Promise<void> | null = null;

  @Input() currentBody;
  @ViewChild('myckeditor', {static: false}) public myckeditor: any;

  ckeditorReady = false;

  ckEditorConfig: {} = {
    height: 100,
    startupFocus: true,
    contentsCss: ["body {font-size: 18px; font-family:Arial, sans-serif;} img {max-width: 100%;}"],
    toolbar: [
      { name: 'document', groups: [ 'mode', 'document', 'doctools' ], items: [ 'Source', '-', 'ExportPdf', 'Preview', '-', 'Templates' ] },
      { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
      { name: 'editing', groups: [ 'find', 'selection', 'spellchecker' ], items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
      { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
      '/',
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ], items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language' ] },
      { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
      { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak' ] },
      '/',
      { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
      { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
      { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
      { name: 'others', items: [ '-' ] }
    ],
    toolbarGroups: [
      { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
      { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
      { name: 'editing', groups: [ 'find', 'selection', 'spellchecker' ] },
      { name: 'forms' },
      '/',
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ] },
      { name: 'links' },
      { name: 'insert' },
      '/',
      { name: 'styles' },
      { name: 'colors' },
      { name: 'tools' },
      { name: 'others' },
      { name: 'about' }
    ],
    // removeButtons: 'Save,NewPage,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Replace,Font,FontSize,SelectAll,Styles,Form,Checkbox,Radio,Select,Button,ImageButton,HiddenField,Strike,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About'
  };

  constructor() { }

  ngOnInit(): void {
    this.loadCKEditor().then(() => this.ckeditorReady = true);
  }

  private loadCKEditor(): Promise<void> {
    if ((window as any).CKEDITOR) return Promise.resolve();
    if (HtmlEditorComponent.ckeditorLoad) return HtmlEditorComponent.ckeditorLoad;

    HtmlEditorComponent.ckeditorLoad = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = HtmlEditorComponent.CKEDITOR_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => { HtmlEditorComponent.ckeditorLoad = null; reject(); };
      document.head.appendChild(script);
    });
    return HtmlEditorComponent.ckeditorLoad;
  }


  public getHtml() {
    return this.currentBody;
  }

  public addAtCursor(_string) {
    this.myckeditor.instance.insertText(_string);
  }

}
